// the most terrible camelizer on the internet, guaranteed!
export default (function (str) {
  return "".concat(str.charAt(0).toLowerCase()).concat(str.replace(/[\W_]/g, '|').split('|').map(function (part) {
    return "".concat(part.charAt(0).toUpperCase()).concat(part.slice(1));
  }).join('').slice(1));
});


// WEBPACK FOOTER //
// ./scripts/util/camelCase.js